/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';

import './styles.css';

const SectionInfoCard = ({ sectionName, sectionCode, onEditClick }) => {
  return (
    <Card className="survey-info-card cursor-pointer" onClick={onEditClick}>
      <Card.Body>
        <div>
          <h4 className="mb-2">Section Name</h4>
          <span>{sectionName}</span>
        </div>
        <div className="pt-3">
          <h4 className="mb-2">Section Code</h4>
          <span>{sectionCode}</span>
        </div>
      </Card.Body>
    </Card>
  );
};

SectionInfoCard.propTypes = {
  sectionName: PropTypes.string.isRequired,
  sectionCode: PropTypes.string,
  onEditClick: PropTypes.func.isRequired,
};

export default SectionInfoCard;
